import {
  faReact,
  faAngular,
  faVuejs,
  faJava,
  faPython,
  faNodeJs,
  faSlack,
  faAws,
  faLinkedinIn, faInstagram, faFacebook, faTwitter, faSalesforce
} from "@fortawesome/free-brands-svg-icons";

import {
  faMobileAlt,
  faCloud,
  faBriefcase,
  faTools,
  faCreditCard,
  faCar,
  faHeadset,
  faChartLine,
  faBullhorn,
  faHexagon,
  faLaptopMedical,
  faRocket,
  faPlug,
  faLaptopCode,
  faCirclePlay,
  faHexagonNodes,
  faLink,
  faHandshake
} from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  react: faReact,
  angular: faAngular,
  vue: faVuejs,
  java: faJava,
  python: faPython,
  node: faNodeJs,
  linkedin: faLinkedinIn,
  instagram: faInstagram,
  facebook: faFacebook,
  twitter: faTwitter,
  salesforce: faSalesforce,
  slack: faSlack,
  aws: faAws,
  mobile: faMobileAlt,
  cloud: faCloud,
  briefcase: faBriefcase,
  tools: faTools,
  credit_card: faCreditCard,
  car: faCar,
  headset: faHeadset,
  chart_line: faChartLine,
  bullhorn: faBullhorn,
  hexagon: faHandshake,
  health: faLaptopMedical,
  rocket: faRocket,
  plug: faPlug,
  code: faLaptopCode,
  play: faCirclePlay,
  network: faHexagonNodes,
  link: faLink
};

export default iconMap;

